var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.782 1V9.62541C19.4474 11.0827 15.764 11.8905 11.891 11.8905C8.01807 11.8905 4.33461 11.0821 1 9.62541V1H1.0011C4.33571 2.45728 8.01917 3.26506 11.891 3.26506C15.7629 3.26506 19.4463 2.45674 22.7809 1H22.782Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.782 23.0001V14.3747C19.4474 12.9174 15.764 12.1096 11.891 12.1096C8.01807 12.1096 4.33461 12.9179 1 14.3747V23.0001H1.0011C4.33571 21.5428 8.01917 20.735 11.891 20.735C15.7629 20.735 19.4463 21.5434 22.7809 23.0001H22.782Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViction);
export default __webpack_public_path__ + "static/media/viction.e0918f202c7f8cfd788558d3fc3334bd.svg";
export { ForwardRef as ReactComponent };